module.exports = __webpack_public_path__ + "media/images/slide_next_btn-e2eee9f415416a384e1ba7221c3f6f26.png";